import {createFileRoute} from '@tanstack/react-router'
import AboutPage from "../landing/AboutPage.tsx";

export const Route = createFileRoute('/about')({
    component: About,
})

function About() {
    return <AboutPage />
}
